import React, { memo, useCallback, useState } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';
import useDialog from '@/components/organisms/useDialog';
import { resetFullClipChanges } from '@/libs/fullRecordingEdit';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';

function RevertChange() {
  const [revertingChanges, setRevertingChanges] = useState(false);

  const { pause } = useRemotionPlayerPause();
  const { clipId } = useClipsContext();
  const {
    isOpen: isResetChangesDialogOpen,
    openDialog: openResetChangesDialog,
    closeDialog: closeResetChangesDialog
  } = useDialog();

  const resetFullRecordingChanges = useCallback(() => {
    pause();
    setRevertingChanges(true);
    resetFullClipChanges(clipId);
    closeResetChangesDialog();
  }, [clipId, closeResetChangesDialog, pause]);

  return (
    <>
      <PlayerTimelineButton
        tooltipTitle="Revert Changes"
        buttonId="new-timeline-revert-changes-button"
        onClick={openResetChangesDialog}
        iconName={revertingChanges ? 'IconLoader' : 'IconRestore'}
        isDisabled={revertingChanges}
      />
      <ConfirmationDialog
        isOpen={isResetChangesDialogOpen}
        onClose={closeResetChangesDialog}
        onConfirm={resetFullRecordingChanges}
        title="Revert Changes"
        content="Are you sure you want to revert to the original version of this video? Your current changes will be lost."
        confirmLabel="Revert Changes"
      />
    </>
  );
}

export default memo(RevertChange);
